<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-4 card-border-blue">
              <b-card-body>
                <p class="text-center">
                  <img
                    src="/images/GS Logo Small.jpg"
                    width="270"
                    class="img-responsive"
                  >
                </p>
                <p v-if="error" class="alert alert-danger">{{ error }}</p>
                <form v-if="!sent" @submit.prevent="submitResetPassword">
                  <h4 class="text-muted text-center mb-3">Reset my password</h4>
                  <b-input-group class="mb-3 default">
                    <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span></div>
                    <input type="text" class="form-control" placeholder="Email" v-model="email">
                  </b-input-group>
                  <b-row>
                    <b-col cols="6" class="text-right">
                      <router-link
                        to="/auth/login"
                        class="btn btn-secondary d-block w-100 default rounded-pill"
                        style="background-color: #8598b2; border-color: #8598b2; padding: 2px 1px;"
                      >Back</router-link>
                    </b-col>
                    <b-col cols="6">
                      <b-btn
                        type="submit"
                        variant="primary"
                        class="d-block w-100 default rounded-pill"
                        style="padding: 2px 1px;"
                      >Reset</b-btn>
                    </b-col>
                  </b-row>
                </form>

                <div v-else>
                  <p class="text-muted text-center mb-3">Check your email inbox for instructions to reset your password.</p>

                  <router-link
                    to="/auth/login"
                    class="btn btn-secondary d-block w-100 default rounded-pill"
                    style="background-color: #8598b2; border-color: #8598b2; padding: 2px 1px;"
                  >Return to login page</router-link>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'Login',

  data() {
    return {
      email: null,
      error: null,
      sent: false,
    };
  },

  methods: {
    ...mapActions(['refreshUser']),
    submitResetPassword(e) {
      axios
        .post('auth/forgot', {
          email: this.email
        })
        .then((response) => {
          this.sent = true;
        })
        .catch((error) => {
          this.error = error.response.data.message;
          this.sent = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Auth/Forgot.vue